module.exports = __webpack_public_path__ + "img/goldrush-locked.51453a67.svg";